// Generated by GitHub Copilot
import configuration from "./index";
import { authFetch } from "../utils/authFetch";

export const WorkflowsAPI = {
  // Get consolidated workflows for a specific problem and outage
  getConsolidated: async function (problemID, outageID) {
    const endpoint =
      configuration.apiBase + `/problem/${problemID}/${outageID}/workflows`;

    const response = await authFetch(endpoint).then((res) => res.json());
    return response.consolidatedWorkflows;
  },

  // Get PagerDuty activity (workflows fired, responders paged/acknowledged,
  // leadership group notified) for a specific problem and outage.
  // Returns the full response object so callers can inspect `available`.
  getPagerDutyActivity: async function (problemID, outageID) {
    const endpoint =
      configuration.apiBase +
      `/problem/${problemID}/${outageID}/pd-activity`;

    const res = await authFetch(endpoint);
    if (!res.ok) {
      throw new Error(
        `Failed to fetch PagerDuty activity: ${res.status} ${res.statusText}`
      );
    }
    return res.json();
  },
};
